import moment from 'moment';

import {
	mapState,
	mapActions,
	mapGetters
} from 'vuex';

import {
	DatePicker
} from 'element-ui';

import {
	cloneDeep
} from 'lodash';

import {
	EventBus
} from '@/support/event-bus';

import toastr from '@/support/toastr';

export default {
	name: 'restocking',
	components: {
		DatePicker
	},
	data: () => ({
		model: {
			product: '',
			quantity: '',
			dueDate: ''
		}
	}),
	computed: {
		...mapGetters({
			klass: 'getClass',
			replacementItens: 'getReplacementItens'
		})
	},
	methods: {
		...mapActions([
			'putReplacementItem',
			'pushReplacementItem',
			'removeReplacementItem'
		]),
		clearModel() {

			this.model = {
				product: '',
				quantity: '',
				dueDate: ''
			};

		},
		addReplacementItem() {

			this.$validator.validateAll().then((valid) => {

				if (valid) {

					if (this.model.index !== undefined && this.model.index >= 0) {

						this.putReplacementItem({
							index: this.model.index,
							value: this.model
						});

					} else {
						this.pushReplacementItem(this.model);
					}

					this.model = {
						product: '',
						quantity: '',
						dueDate: ''
					};

				} else {
					toastr.warning('Por favor informar todos os campos relacionados aos itens de reposição');
				}

			});

		},
		editReplacementItem(index) {

			this.model = cloneDeep(this.replacementItens[index]);
			this.model.index = index;

		},
	},
	mounted() {

		EventBus.$on('setStudent', () => {
			this.clearModel();
		});

	},
	beforeDestroy() {

		EventBus.$off('setStudent');

	}
};



// WEBPACK FOOTER //
// ./sources/domains/agenda/others/restocking/index.js